import {BackendApi} from '../api/api.ts'

export type GLAccountRef = {
    code: string
    description: string
}

export type RunImportResult = {
    runRef: string
    periodStart: string
    periodEnd: string
    status: string
    importId: string
    unmappedGlAccounts: GLAccountRef[]
}

export type ImportRecord = {
    importId: string
    administrationId: string
    runRef: string
    runSequenceNumber: number
    periodStart: string
    periodEnd: string
    status: string
    createdAt: unknown
    postedAt: unknown
}

export async function runImport(api: BackendApi, administrationId: string, syncFrom: string): Promise<RunImportResult[]> {
    const response = await api.Partner__payroll__imports({
        administration_id: administrationId,
        sync_from: syncFrom,
    })
    return response.results.map(r => ({
        runRef: r.run_ref,
        periodStart: r.period_start,
        periodEnd: r.period_end,
        status: r.status,
        importId: r.import_id,
        unmappedGlAccounts: r.unmapped_gl_accounts.map(a => ({code: a.code, description: a.description})),
    }))
}

export async function listImportHistory(
    api: BackendApi,
    administrationId: string,
): Promise<ImportRecord[]> {
    const response = await api.Partner__payroll__imports__history(administrationId)
    return response.imports.map(i => ({
        importId: i.import_id,
        administrationId: i.administration_id,
        runRef: i.run_ref,
        runSequenceNumber: i.run_sequence_number,
        periodStart: i.period_start,
        periodEnd: i.period_end,
        status: i.status,
        createdAt: i.created_at,
        postedAt: i.posted_at,
    }))
}

export function formatImportDate(value: unknown): string {
    if (value == null) return '-'
    const s = String(value)
    const dateOnlyMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s)
    if (dateOnlyMatch) {
        const [, year, month, day] = dateOnlyMatch
        return `${day}-${month}-${year}`
    }
    const d = new Date(s)
    if (Number.isNaN(d.getTime())) return s
    return d.toLocaleDateString('nl-NL', {day: '2-digit', month: '2-digit', year: 'numeric'})
}

export function importStatusLabel(status: string): string {
    if (status === 'POSTED') return 'Geboekt'
    if (status === 'STAGED') return 'Wacht op koppeling'
    if (status === 'FAILED') return 'Mislukt'
    if (status === 'AWAITING_PROVIDER') return 'In voorbereiding'
    return status
}

export function hasAwaitingProviderRuns(records: ImportRecord[]): boolean {
    return records.some(r => r.status === 'AWAITING_PROVIDER')
}
